<template>
    <div>
        <card-header title="Recent Reviews" icon="fa-timer"/>

        <card-body>
            <card-list>
                <template v-if="reviews.enroll_applications && reviews.enroll_applications.length">
                    <subheader-list-item title="Enrollment Applications" icon="fa-file-certificate" :badge="reviews.enroll_applications.length"/>

                    <card-list-item
                        @click="$openCard('application-applicant', {applicantId: app.id, applicationId: app.course_applications.application_id, applicantType: 'course'}, card)"
                        :class="{'active': child && child.definition.component === 'application-applicant' && child.props.applicantId == app.id}"
                        v-for="app in reviews.enroll_applications"
                    >

                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="meta">{{app.course_applications.applications.title}}</div>
                            <div class="tile-title">{{app.users.first_name}} {{app.users.last_name}}</div>
                            <div class="tile-title">{{app.enrollments.courses.title}}</div>
                            <div class="meta mt-1 has-text-success has-text-weight-bold" v-if="app.completed_at"><i class="far fa-check mr-2"></i>Application Completed/Approved</div>
                            <div class="meta mt-1">{{app.updated_at | moment('MMMM Do, h:mm A')}}, {{app.total_units}} of {{app.course_applications.max_units}} {{app.course_applications.applications.certification_certs.certifications.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>

                <template v-if="reviews.reg_applications && reviews.reg_applications.length">
                    <subheader-list-item title="Registration Applications" icon="fa-file-certificate" :badge="reviews.reg_applications.length"/>

                    <card-list-item
                        @click="$openCard('application-applicant', {applicantId: app.id, applicationId: app.conf_application.application_id, applicantType: 'conf'}, card)"
                        :class="{'active': child && child.definition.component === 'application-applicant' && child.props.applicantId == app.id}"
                        v-for="app in reviews.reg_applications"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="meta">{{app.conf_application.application.title}}</div>
                            <div class="tile-title">{{app.user.first_name}} {{app.user.last_name}}</div>
                            <div class="tile-title">{{app.conference.title}}</div>
                            <div class="meta mt-1 has-text-danger has-text-weight-bold" v-if="app.is_rejected"><i class="far fa-ban mr-2"></i>Application Terminated</div>
                            <div class="meta mt-1 has-text-warning has-text-weight-bold" v-if="app.deleted_at"><i class="far fa-ban mr-2"></i>Application Reset/Deleted</div>
                            <div class="meta mt-1 has-text-success has-text-weight-bold" v-if="app.completed_at && !app.is_rejected && !app.deleted_at"><i class="far fa-check mr-2"></i>Application Completed/Approved</div>
                            <div class="meta mt-1">{{app.updated_at | moment('MMMM Do, h:mm A')}}, {{app.total_units}} of {{app.conf_application.max_units}} {{app.conf_application.certification.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>

                <template v-if="reviews.conf_applications && reviews.conf_applications.filter(app => app.updated_at).length">
                    <subheader-list-item title="Conference Certification Applications" icon="fa-file-certificate" :badge="reviews.conf_applications.filter(app => app.updated_at).length"/>

                    <card-list-item
                        v-for="app in this.reviews.conf_applications.filter(app => app.updated_at)"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="tile-title">{{app.applications.title}}</div>
                            <div class="meta">{{app.conferences.title}}</div>
                            <div class="meta mt-1">Updated {{app.updated_at | moment('MMMM Do')}}, {{app.max_units}} {{app.applications.certification_certs.certifications.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>

                <template v-if="reviews.course_applications && reviews.course_applications.filter(app => app.updated_at).length">
                    <subheader-list-item title="Course Certification Applications" icon="fa-file-certificate" :badge="reviews.course_applications.filter(app => app.updated_at).length"/>

                    <card-list-item
                        v-for="app in this.reviews.course_applications.filter(app => app.updated_at)"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="tile-title">{{app.applications.title}}</div>
                            <div class="meta">{{app.courses.title}}</div>
                            <div class="meta mt-1">Updated {{app.updated_at | moment('MMMM Do')}}, {{app.max_units}} {{app.applications.certification_certs.certifications.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>


            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from "@/http_client";
    import ReviewTile from "../../components/tiles/ReviewTile";
    import async from "async";
    import CardListItem from "../../TIER/components/CardListItem";
    import Toolbar from "../../TIER/components/Toolbar";
    import {mapActions, mapGetters} from "vuex";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem.vue";
    import NavigationListItem from "../../TIER/components/NavigationListItem.vue";
    import ApplicantTile from "../../components/tiles/ApplicantTile.vue";

    export default {
        components: {ApplicantTile, NavigationListItem, SubheaderListItem, Toolbar, CardListItem, ReviewTile, CardToolbar, SeparatorListItem, CardHeader, CardBody, CardList},
        props: ['card', 'child'],
        data() {
            return {
                reviews: []
            };
        },
        methods: {
            load: function() {
                http.get('/review/recent').then(response => {
                    this.reviews = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.error(err);
                });
            },
            reload: function() {
                this.load();
            }
        },
        mounted: function() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
